import { useNavigate } from "react-router-dom";
import NoteBook from "./NoteBook";

export default function Note() {
  const navigate = useNavigate();
  return (
    <div className="note-for-crush bg-transparent bg-gradient-to-br from-[#3a1c71] via-[#d76d77] to-[#ffaf7b] w-full min-h-screen flex flex-col flex-wrap gap-0 sm:gap-6 justify-center items-center">
      <div className="up-content flex items-center justify-center">
        <div className="note-card flex items-center justify-between ">
          <NoteBook />
        </div>
      </div>
      <div className="down-content w-fit h-fit flex flex-col flex-wrap items-center justify-center gap-2 sm:gap-10">
        <div
          onClick={() => navigate("/memories")}
          className={` text-center video video-animation w-80 sm:w-[34rem] lg:w-[36rem] h-auto -rotate-6 p-[6px] mx-auto my-5 bg-transparent bg-gradient-to-r from-[#0099F7] to-[#F11712] rounded-xl shadow-2xl`}
        >
          Open book and see our memories or click this
        </div>
        <div className="btn ">
          <button
            className="btn btn-next rounded-sm"
            data-next="letter"
            onClick={() => navigate(-1)}
          >
            Back
          </button>
          <button
            className="btn btn-next"
            onClick={() =>
              window.open("https://www.instagram.com/direct/t/102337454496554/")
            }
          >
            Insta Chat ?
          </button>
        </div>
      </div>
    </div>
  );
}
